import { render, staticRenderFns } from "./BaseTwoColumnsRow.vue?vue&type=template&id=28183f95&scoped=true&"
import script from "./BaseTwoColumnsRow.vue?vue&type=script&lang=ts&"
export * from "./BaseTwoColumnsRow.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTwoColumnsRow.vue?vue&type=style&index=0&id=28183f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28183f95",
  null
  
)

export default component.exports